// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1d12e1bd","453":"099ba8e3","455":"266e7e1d"}[chunkId] + ".chunk.js";
};